import { Button, IconButton } from "@mui/material";
import React, { useCallback } from "react";
import { useIsMobile } from "../../../../hooks/useIsMobile";
import { useNavigate, useSearchParams } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import { useLanguage } from "@tlc/ls2pac/components/Language";

export function EditAdvancedSearchButton() {
  const isMobile = useIsMobile();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { translate } = useLanguage();

  const onClick = useCallback(() => {
    const params = new URLSearchParams(searchParams);
    params.delete("page"); // ensures form submission shows first page of results
    navigate({ pathname: "..", search: `?${params.toString()}` });
  }, [searchParams]);

  if (isMobile) {
    return (
      <IconButton
        color="primary"
        aria-label={translate("edit")}
        onClick={onClick}
      >
        <EditIcon />
      </IconButton>
    );
  }

  return (
    <Button startIcon={<EditIcon />} onClick={onClick}>
      {translate("edit")}
    </Button>
  );
}
